import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface AppConfig {
  appName: string;
}

const defaultConfig: AppConfig = {
  appName: 'A+智能体系统',
};

const AppConfigContext = createContext<AppConfig>(defaultConfig);

export const useAppConfig = () => useContext(AppConfigContext);

export const AppConfigProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<AppConfig>(defaultConfig);

  useEffect(() => {
    // Check if config was injected at build time (via window.__APP_CONFIG__)
    const injected = (window as any).__APP_CONFIG__;
    if (injected?.appName) {
      setConfig(injected);
      return;
    }

    // Try to fetch from public directory (works in dev and some build setups)
    fetch('/app-config.json')
      .then((res) => {
        if (res.ok) return res.json();
        return null;
      })
      .then((data) => {
        if (data?.appName) {
          setConfig(data);
        }
      })
      .catch(() => {
        // Use default config if file doesn't exist
      });
  }, []);

  return (
    <AppConfigContext.Provider value={config}>
      {children}
    </AppConfigContext.Provider>
  );
};
